export default "__VITE_ASSET__xdL3sP3U__"